// src/core/assets/index.ts
// Central assets barrel — imports split into icons and images
// See icons.ts for all icon assets (react-icons/lu only)
// See images.ts for all image/SVG URL assets (public/)

export * from "./icons";
export * from "./images";
export type { IconKey } from "./icons";
export type { ImageKey } from "./images";

// ── Backward-compat combined record ──────────────────────────────────────────
// 142 consumer files use: import { assets } from "@/core/assets"
// This keeps that API working without touching any component files.
// New code should prefer the typed `icons` or `images` records directly.
import type { IconType } from "react-icons";
import { icons, type IconKey } from "./icons";
import { images, type ImageKey } from "./images";

export const assets: Record<string, IconType | string> = { ...icons, ...images };
export type AssetKey = IconKey | ImageKey;
